export const PPAC_API_URL = process.env.PP_API_URL || 'https://agency-card-bff.assured-muskrat-live.aws.aviv.eu/v1'; // live env used by default
export const API_ROUTES = {
    AGENCIES_API_URL: `/agencies/`,
    AGENCY_API_URL: `/agency/`,
    ZIPCODE_AGENCIES_API_URL: `/recommendation/zipcode/`,
};
